import { Actions, Subjects } from 'src/permissions/ability';
import { useAbility } from 'src/permissions/hooks/useAbility';

export const useIsCslUser = () => {
  const ability = useAbility();
  const isCSLUser = ability.can(Actions.read, Subjects.internalData);

  return isCSLUser;
};
